<template>
  <!-- TODO FIX see: primair_onderwijs\voortgezet_onderwijs/school.php -->
  <div v-if="visible || ouderbijdrage">
    <h3>Extra</h3>
    <table class="table table-condensed">
      <tbody>
        <template v-for="row in rows">
          <tr
            v-if="rowVisible(row)"
            :key="row.title"
          >
            <th>{{ row.title }}</th>
            <td v-html="row.value" />
          </tr>
        </template>
        <tr v-if="ouderbijdrage">
          <th>ouderbijdrage ({{ ouderbijdrage.schooljaar }})</th>
          <td>
            &euro; {{ ouderbijdrage.kosten }}{{ ouderbijdrage.kosten_uitleg }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
    jaren: {
      required: true,
      type: Array,
    },
  },

  data() {
    const { school } = this;
    return {
      rows: [
        {
          title: 'buitenschools',
          value: school.buitenschools,
        },
        {
          title: 'excursies',
          value: school.excursies,
        },
        {
          title: 'inzet leerlingen',
          value: school.inzet_leerlingen,
        },
        {
          title: 'ouderbijdrage',
          value: school.ouderbijdrage,
        },
      ],
      ouderbijdrage: null,
    };
  },
  computed: {
    visible() {
      if (!this.rows) {
        return false;
      }
      const visibleRow = this.rows.find((row) => this.rowVisible(row));
      return isset(visibleRow);
    },
    schoolJaren() {
      return this.jaren.filter((j) => j.school_id === this.school.id);
    },
  },
  created() {
    this.ouderbijdrage = this.schoolJaren.reduce((prev, cur) => {
      if (!prev) {
        return cur;
      }
      if (prev.schooljaar <= cur.schooljaar && cur.kosten !== 0) {
        return cur;
      }
      return prev;
    }, null);
  },
  methods: {
    rowVisible(row) {
      return row.show === true || (row.show === undefined && row.value);
    },
  },
};

function isset(value) {
  return !!value;
}
</script>
